import DataTableEditableAutocompleteCell from './DataTableEditableAutocompleteCell';

export default DataTableEditableAutocompleteCell;
